import dynamic from 'next/dynamic'
import type { ContactFormProps } from '@mc/enterprise-contact-form'

export const ContactForm = dynamic<ContactFormProps>(
  import(
    /* webpackChunkName: 'enterprise-landing-contact-form' */
    '@mc/enterprise-contact-form'
  ).then((pkg) => pkg.ContactForm),
  {
    ssr: false,
  },
)
